"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.keyframes = exports.useTheme = exports.createGlobalStyle = exports.ThemeProvider = exports.css = exports.styled = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const styled_components_1 = __importStar(require("styled-components"));
exports.styled = styled_components_1.default;
Object.defineProperty(exports, "css", { enumerable: true, get: function () { return styled_components_1.css; } });
Object.defineProperty(exports, "ThemeProvider", { enumerable: true, get: function () { return styled_components_1.ThemeProvider; } });
Object.defineProperty(exports, "createGlobalStyle", { enumerable: true, get: function () { return styled_components_1.createGlobalStyle; } });
Object.defineProperty(exports, "keyframes", { enumerable: true, get: function () { return styled_components_1.keyframes; } });
const _useThemeTypeOverriden = styled_components_1.useTheme;
exports.useTheme = _useThemeTypeOverriden;
exports.default = styled_components_1.default;
//# sourceMappingURL=styled-components.js.map